// src/features/hmis/hooks/useHMIPermissions.tsx
import { usePermissions } from 'react-admin';
import { HMIDetailResponse } from '../types';

export interface UseHMIPermissionsResult {
  canViewHMIs: boolean;
  canCreateHMIs: boolean;
  canEditHMIs: boolean;
  canDeleteHMIs: boolean;
  canGenerateProvisioningCode: boolean;
  canResetApiKey: boolean;
  canConfigureNetwork: boolean;
  isLoading: boolean;
}

export const useHMIPermissions = (hmi?: HMIDetailResponse | null): UseHMIPermissionsResult => {
  const { permissions, isLoading } = usePermissions();
  
  const role = permissions || '';
  
  // Definir permisos según el rol
  const canViewHMIs = ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role);
  const canCreateHMIs = ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role);
  const canEditHMIs = ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role);
  const canDeleteHMIs = ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role);
  const canGenerateProvisioningCode = ['SuperAdmin', 'GroupAdmin', 'HotelAdmin'].includes(role);
  const canResetApiKey = ['SuperAdmin'].includes(role);
  const canConfigureNetwork = ['SuperAdmin', 'GroupAdmin'].includes(role);
  
  return {
    canViewHMIs,
    canCreateHMIs,
    canEditHMIs,
    canDeleteHMIs,
    canGenerateProvisioningCode,
    canResetApiKey,
    canConfigureNetwork,
    isLoading,
  };
};